export const summarizeActions = rows => rows.reduce((summary, row) => ({
  total: summary.total + 1,
  missingNextAction: summary.missingNextAction + (row.nextActionAt ? 0 : 1),
  critical: summary.critical + (row.priority?.severity === 'CRITICAL' ? 1 : 0),
  high: summary.high + (row.priority?.severity === 'HIGH' ? 1 : 0),
}), { total: 0, missingNextAction: 0, critical: 0, high: 0 });

export const profitabilityCoverageLabel = coverage =>
  `${coverage.customersWithCosts || 0} of ${coverage.customers || 0} customers have cost data`;
